module.exports = __webpack_public_path__ + "static/media/homepage-messages.081e468c.svg";